const accessorials = [
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CAPPT",
		"description": "Appointment Required",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CCARR",
		"description": "Carrier Hub Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CCOMM",
		"description": "Commercial Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "DELNO",
		"description": "Deliver Notification",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CIDEL",
		"description": "Inside Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CLFTG",
		"description": "Liftgate Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CMARK",
		"description": "Marking and Tagging",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CNBD",
		"description": "Non-Business Hours Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CNYCM",
		"description": "NYC Metro",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CJACK",
		"description": "Pallet Jack",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CRDEL",
		"description": "Residential Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CSHIP",
		"description": "Shipper Hub Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "CSORT",
		"description": "Sort and Segregate",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "LTDEL",
		"description": "Trade Show Delivery",
	},
	{
		"accessorialType": "CDOCK",
		"abbreviation": "THD",
		"description": "Two Hour Special Delivery",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SMAN",
		"description": "2nd Man",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "AGE",
		"description": "Age Restricted",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBIND",
		"description": "Binders",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBSCH",
		"description": "Blanket Service - Chilled",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBSFZ",
		"description": "Blanket Service - Frozen",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBSHP",
		"description": "Blind Shipment",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "BLKHD",
		"description": "Bulkhead",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LCHAI",
		"description": "Chains Required",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBOND",
		"description": "Customs In-Bond",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LEXPD",
		"description": "Expedited",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LFGP",
		"description": "Food Grade Products",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LGUAR",
		"description": "Guaranteed",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LHDEL",
		"description": "Holiday Delivery",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LHPCK",
		"description": "Holiday Pickup",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "ASSEM",
		"description": "Light Assembly",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LSTRA",
		"description": "Must Be Strapped",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "NOSG",
		"description": "No Signature",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LODIM",
		"description": "Over Dimension",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "PRORE",
		"description": "Proactive Response",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LBSRV",
		"description": "Protect from Freezing",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "RESDE",
		"description": "Restricted Delivery",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "RETRE",
		"description": "Return Receipt",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "ROCH",
		"description": "Room of Choice",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SATDE",
		"description": "Saturday Delivery",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SHLD",
		"description": "Shipment Hold",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SHIRE",
		"description": "Shipper Release",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SIGRQ",
		"description": "Signature Required",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LSING",
		"description": "Single Shipment",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "SPEHA",
		"description": "Special Handling",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LSTAC",
		"description": "Stackable",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LSTAK",
		"description": "Stakes Required",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LTEDR",
		"description": "Tanker Endorsed Driver Required",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "THRS",
		"description": "Threshold",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LTIME",
		"description": "Time Definite",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LTSA",
		"description": "TSA",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LTKEY",
		"description": "Turnkey",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LPSLA",
		"description": "Unattended",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LVSHP",
		"description": "Volume Shipment",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "LWDET",
		"description": "Weight Determination",
	},
	{
		"accessorialType": "LOAD",
		"abbreviation": "WGLV",
		"description": "White Glove",
	},
	{
		"accessorialType": "MANDATORY",
		"abbreviation": "COD",
		"description": "COD",
	},
	{
		"accessorialType": "MANDATORY",
		"abbreviation": "DL",
		"description": "Declared Liability",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SAPPT",
		"description": "Appointment Required",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SCARR",
		"description": "Carrier Hub Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SCOMM",
		"description": "Commercial Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SIPCK",
		"description": "Inside Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SLFTG",
		"description": "Liftgate Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SMARK",
		"description": "Marking and Tagging",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SNBP",
		"description": "Non-Business Hours Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SNYCM",
		"description": "NYC Metro",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SJACK",
		"description": "Pallet Jack",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SRPCK",
		"description": "Residential Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SSHIP",
		"description": "Shipper Hub Pickup",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "SSORT",
		"description": "Sort and Segregate",
	},
	{
		"accessorialType": "SDOCK",
		"abbreviation": "LTPCK",
		"description": "Trade Show Pickup",
	},
]

const equipmentType = [ //value is array pos
	{ code: "Trailer_28ft", name: "Trailer - 28ft" },
	{ code: "Other", name: "Other" },
	{ code: "Trailer_48ft", name: "Trailer - 48ft" },
	{ code: "Tanker", name: "Tanker" },
	{ code: "RailCar_20ft", name: "Rail Car - 20ft" },
	{ code: "VanTrailer_Standard", name: "Van-standard trailer" },
	{ code: "VanTrailer_53ft", name: "53ft - Van Trailer" },
	{ code: "Trailer_26ft", name: "Trailer – 26ft" },
	{ code: "Dumper_60yd", name: "Dumper - 60 yard" },
	{ code: "CarCarrier", name: "Car-Carrier" },
	{ code: "DoubleDrop", name: "Double Drop" },
	{ code: "RailCar_40ft", name: "Rail Car - 40ft" },
	{ code: "Dumper_80yd", name: "Dumper - 80 yard" },
	{ code: "StraightTruck_24ft_LiftGate", name: "	24ft Straight Truck w/ lift gate" },
	{ code: "Trailer_24ft", name: "Trailer – 24ft" },
	{ code: "StraightTruck_24ft", name: "24ft Straight Truck" },
	{ code: "Container_45ft", name: "Container - 45ft" },
	{ code: "Truck_4by4", name: "4x4" },
	{ code: "StraightTruck_26ft_LiftGate", name: "26ft Straight Truck w/ lift gate" },
	{ code: "DumpTruck", name: "Dump Truck" },
	{ code: "Gooseneck", name: "Gooseneck" },
	{ code: "Dumper_40yd", name: "Dumper - 40 yard" },
	{ code: "Van", name: "Van" },
	{ code: "Container_40HQ", name: "Container - 40HQ" },
	{ code: "Truck", name: "Truck" },
	{ code: "SprinterVan", name: "Sprinter Van" },
	{ code: "HopperBottom", name: "Hopper Bottom" },
	{ code: "Car", name: "Car" },
	{ code: "StraightTruck_26ft", name: "26ft Straight Truck" },
	{ code: "Dumper_20yd", name: "Dumper - 20 yard" },
	{ code: "AirCargo", name: "Air Cargo" },
	{ code: "MaxiTrailer", name: "Maxi Trailer" },
	{ code: "Frozen", name: "Frozen" },
	{ code: "BoxTruck_LiftGate", name: "Box truck w/ lift gate" },
	{ code: "Van_LiftGate", name: "Van w/ lift gate" },
	{ code: "StepDeck", name: "Step Deck" },
	{ code: "Truck_LiftGate", name: "Truck w/ lift gate" },
	{ code: "RollOff", name: "Roll-off Truck" },
	{ code: "Container_53ft", name: "Container - 53ft" },
	{ code: "Container_20ft", name: "Container - 20ft" },
	{ code: "Refrigerated", name: "Refrigerated" },
	{ code: "WalkingFloor", name: "Walking Floor" },
	{ code: "Container_40ft", name: "Container - 40ft" },
	{ code: "RailCar_53ft", name: "Rail Car - 53ft" },
	{ code: "LowBoy", name: "Low Boy" },
	{ code: "FlatBed", name: "Flat Bed" },
	{ code: "PickupTruck", name: "Pickup Truck" },
	{ code: "BoxTruck", name: "Box truck" },
	{ code: "ParcelTruck", name: "Parcel Truck" },
	{ code: "Van_TriAxle", name: "Tri-Axle Van" },
	{ code: "Bulk_Truck", name: "Bulk Truck" },
	{ code: "Removable_Gooseneck", name: "Removable Gooseneck" },
	{ code: "Winch_Truck", name: "Winch Truck" },
	{ code: "Tractor", name: "Tractor" },
	{ code: "Straight16", name: "16 Ft Straight Truck" },
	{ code: "Straight18", name: "18 Ft Straight Truck" },
	{ code: "Cargo_Van", name: "Cargo Van" },
	{ code: "Tractor_Trailer", name: "Tractor Trailer" },
	{ code: "Full_Size_Van", name: "Full Size Van" },
	{ code: "Minivan", name: "Minivan" },
	{ code: "Doubles", name: "Doubles" },
	{ code: "Trailer53", name: "Trailer-53Ft" },
]

const packageType = [
	"Accessorials",
	"Attachments",
	"Bags",
	"Bales",
	"Baskets",
	"Bulkheads",
	"Bundles",
	"Boxes",
	"Barrels",
	"Buckets",
	"Carboys",
	"Cases",
	"Chests",
	"Coils",
	"Cartons",
	"Crates",
	"Container",
	"Cylinders",
	"Drums",
	"Envelopes",
	"Feet",
	"Firkins",
	"Gaylords",
	"Kegs",
	"Loose",
	"Octabin",
	"Packages",
	"Pails",
	"Pieces",
	"Pallets",
	"Racks",
	"Reels",
	"Rolls",
	"Skids",
	"SlipSheets (Slip Sheets)",
	"SuperSack (Super Sack)",
	"Totes",
	"Truckload",
	"Trailers",
	"Trunks",
	"Trays",
	"Tubes",
	"Units",
	"Unpackaged",
	"Vehicles",
	"Bins",
	"Tubs",
	"Each",
	"PlasticJerricans (Plastic Jerricans)",
]

const incoTerm = [
	"Free Alongside Ship",
	"Free Onboard",
	"Cost and Freight",
	"Cost Insurance and Freight",
	"Carriage Paid To",
	"Carriage and Insurance Paid",
	"Delivered at Terminal",
	"Delivered at Place",
	"Delivered Duty Paid",
	"Delivered at Frontier",
	"Delivered ExShip",
	"Delivered ExQuay",
	"Delivered Duty Unpaid",
	"Free Carrier",
	"ExWorks",
]

const serviceCode = [
	"Parcel",
	"LTL",
	"Volume",
	"Air",
	"Ocean",
	"GFP",
	"Local Carrier",
	"FTL",
	"Driveway",
	"Intermodal",
	"Expedite",
]

const freightClass = [
	"Unspecified",
	"c50",
	"c55",
	"c60",
	"c65",
	"c70",
	"c775",
	"c85",
	"c925",
	"c100",
	"c110",
	"c125",
	"c150",
	"c175",
	"c200",
	"c250",
	"c300",
	"c400",
	"c500",
]

const unitOfMeasure = [
	"English",
	"Metric",
]

const deliveryConfirmationType = [

]

const codType = [
	"None",
	"StandardCOD",
	"SecuredFunds",
]

const payTypes = [
	"Prepaid",
	"Collect",
]

const shipTypes = [
	"Shipper",
	"Consignee",
	"ThirdParty",
]

module.exports = {
	accessorials,
	packageType,
	codType,
	deliveryConfirmationType,
	equipmentType,
	freightClass,
	incoTerm,
	serviceCode,
	unitOfMeasure,
	payTypes,
	shipTypes,
}
